import { AsyncThunkAction } from 'actions/actions.types'
import { Direction } from 'components/page/RatingWave/Rating.types'

import { dislikePhotoNextAction } from './dislikePhotoNextAction'
import { likePhotoNextAction } from './likePhotoNextAction'

export const votePhotoNextAction =
  (direction: Direction, photoId: number): AsyncThunkAction =>
  (dispatch) => {
    switch (direction) {
      case Direction.right:
        return dispatch(likePhotoNextAction(photoId, 1))

      case Direction.left:
        return dispatch(dislikePhotoNextAction(photoId))

      default:
        return null
    }
  }
